import { ApiaApi } from '@apia/api';
import { KeyboardEvent, MouseEvent } from 'react';
import { firePanelAction } from './firePanelAction';
import { eventsController, TPanelIdentifier } from '../eventsController';
import { downloadUrl } from '@apia/util';

export type TActionBehavior =
  | 'DO_NOTHING'
  | 'NAVIGATE_URL'
  | 'CALL_AJAX_URL'
  | 'RUN_ACTION'
  | 'OPEN_TAB'
  | 'FIRE_EVENT'
  | 'DOWNLOAD';

export type TActionSource = 'CLICK' | 'DOUBLE_CLICK';

export type TBasicAction = {
  action: string;
  actionBehavior: TActionBehavior;
  actionSource: TActionSource;
  additionalData: string;
  text: string;
};

interface ITabsController {
  openTabByUrl(title: string, url: string): void;
}

export function handleAction(
  panelIdentifier: TPanelIdentifier,
  event: KeyboardEvent | MouseEvent,
  action: TBasicAction,
) {
  if (
    (event.type === 'dblclick' && action.actionSource === 'DOUBLE_CLICK') ||
    ((event.type === 'click' || event.type === 'mousedown') &&
      action.actionSource === 'CLICK') ||
    (event.type === 'keydown' && (event as KeyboardEvent).code === 'Enter')
  ) {
    if (action?.action) {
      switch (action.actionBehavior) {
        case 'CALL_AJAX_URL':
          void ApiaApi.post(action.action, { handleLoad: true });
          break;
        case 'DO_NOTHING':
          break;
        case 'NAVIGATE_URL':
          window.location.assign(action.action);
          break;
        case 'OPEN_TAB':
          (
            window.top as unknown as { tabsController: ITabsController }
          )?.tabsController.openTabByUrl(
            action.additionalData || action.text,
            action.action,
          );
          break;
        case 'RUN_ACTION':
          firePanelAction(
            panelIdentifier.panelId,
            action.action,
            {},
            { requestConfig: { handleLoad: true } },
          );
          break;
        case 'FIRE_EVENT':
          eventsController.fireEvent(
            panelIdentifier,
            action.action,
            JSON.parse(action.additionalData),
          );
          break;
        case 'DOWNLOAD':
          downloadUrl(action.action);
          break;
        default:
          console.error('Unknown action behavior: ', action);
      }
    }
  }
}
